module.exports = __webpack_public_path__ + "static/img/2.0ef539bd.png";